<template>
    <svg
        class="icon-external fill-current"
        viewBox="0 0 19.384 19.384"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M16.355,12.115H15.144a.606.606,0,0,0-.606.606v4.24H2.423V4.846H7.875a.606.606,0,0,0,.606-.606V3.029a.606.606,0,0,0-.606-.606H1.817A1.817,1.817,0,0,0,0,4.24V17.567a1.817,1.817,0,0,0,1.817,1.817H15.144a1.817,1.817,0,0,0,1.817-1.817V12.721A.606.606,0,0,0,16.355,12.115ZM17.971,0H11.964A1.06,1.06,0,0,0,10.9,1.06v.708A1.06,1.06,0,0,0,11.993,2.8l2.545-.072L5.113,12.081l0,0a.909.909,0,0,0,0,1.285l.906.9,0,0a.909.909,0,0,0,1.284,0l9.355-9.424-.071,2.545v.03a1.06,1.06,0,0,0,1.06,1.06h.677a1.06,1.06,0,0,0,1.06-1.06V1.413h0A1.413,1.413,0,0,0,17.971,0Z" />
    </svg>
</template>
